import React, { useCallback } from "react";
import { GooglePicker } from "~/components/Google/GooglePicker";
import Angie from "~/utils/angie.jsx";
import { showErrorToast } from "./Toast/index.js";

const ContainerGooglePicker = (props) => {
  const onGoogleAuthError = useCallback((message) => {
    showErrorToast(message);
    Angie.logger.info(message);
  }, []);

  return (
    <div>
      <GooglePicker
        {...props}
        onGoogleAuthError={onGoogleAuthError}
      />
    </div>
  );
};

export default ContainerGooglePicker;
